import React, { useEffect, useState } from "react";
import DefaultLayout from "../components/DefaultLayout";
import axios from "axios";
import { Row, Col, Input } from "antd";
import { io } from "socket.io-client";

import BillList from "../components/BillList";
import config from "../config";

const Bills = () => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;
  // const { Search } = Input;
  const [filteredTablesData, setFilteredTablesData] = useState([]);
  // const [searchText, setSearchText] = useState("");
  const [tablesData, setTablesData] = useState([]);
  // Orders state for all tables
  const [tableOrders, setTableOrders] = useState({}); // { [tableNumber]: [orders] }
  // Taxes and services state
  const [taxes, setTaxes] = useState([]);
  const [services, setServices] = useState([]);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    const getAllItems = async () => {
      try {
        const { data } = await axios.get(`${apiBaseUrl}/api/tables/get-table`);

        setTablesData(data.filter(table => table.table_status === true));
        setFilteredTablesData(data.filter(table => table.table_status === true));
        console.log("Tables data:", data);
      } catch (error) {
        console.log(error);
      }
    };
    getAllItems();
  }, []);

  // useEffect(() => {
  //   if (searchText) {
  //     setFilteredTablesData(tablesData.filter(table => table.table_number.includes(searchText)));
  //   } else {
  //     setFilteredTablesData(tablesData);
  //   }
  // }, [searchText]);

  // search: not distinguishing capitals from lower case letters
  const handleSearch = (searchValue) => {
    const lowerSearchValue = searchValue.toLowerCase(); 

    if (searchValue) {
      setFilteredTablesData(
        tablesData.filter(table =>
          table.table_number.toLowerCase().includes(lowerSearchValue)
        )
      );
      console.log("tablesData", tablesData, searchValue);
    } else {
      setFilteredTablesData(tablesData);
    }
  };

  // Fetch orders for all tables
  const fetchTableOrders = async () => {
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/orders/get-all-orders`);
      const grouped = {};
      data.forEach(order => {
        if (!grouped[order.order_tablenumber]) grouped[order.order_tablenumber] = [];
        grouped[order.order_tablenumber].push(order);
      });
      setTableOrders(grouped);
    } catch (error) {
      console.error("Error fetching all orders:", error);
    }
  };

  // Fetch taxes
  const fetchTaxes = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/api/taxes/get-taxes`);
      setTaxes(response.data);
    } catch (error) {
      console.error("Error fetching taxes:", error);
    }
  };

  // Fetch services
  const fetchServices = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/api/services/get-services`);
      setServices(response.data);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/api/settings/get-settings`);
      setSettings(response.data || {});
    } catch (error) {
      console.error("Error fetching settings:", error);
      return {};
    }
  };

  // Initial load of orders, taxes, and services
  useEffect(() => {
    fetchTableOrders();
    fetchTaxes();
    fetchServices();
    fetchSettings();
  }, []);

  // Socket.io logic for real-time updates
  useEffect(() => {
    const socket = io(config.REACT_APP_API_BASE_URL, { transports: ["websocket"] });
    socket.on("newOrder", () => {
      fetchTableOrders();
      fetchTaxes();
      fetchServices();
    });
    return () => socket.disconnect();
  }, []);

  return (
    <DefaultLayout searchPlaceholder="Table Name" onSearch={handleSearch}>
      {/* <Search
        placeholder="Search"
        onChange={e => setSearchText(e.target.value)}
        style={{ width: 200, marginLeft: 11  }}
        allowClear
      /> */}

      <Row>
        {filteredTablesData.map((table, index) => (
          <Col key={index} xs={24} lg={6} md={12} sm={6}>
            <BillList 
              table={table} 
              tableOrders={tableOrders[table.table_number] || []} 
              taxes={taxes}
              services={services}
              settings={settings}
            />
          </Col>
        ))}
      </Row>
    </DefaultLayout>
  );
};

export default Bills;
